import { createSlice } from "@reduxjs/toolkit";
import { DebugStoreState } from "./types";

// // // //

// Define the initial state of the toaster store
const initialState: DebugStoreState = {
    debug_preview_features: false,
};

// Define the slice for the toaster store, including the initial state and reducer functions
const debugSlice = createSlice({
    name: "debug",
    initialState,
    reducers: {
        toggleDebugPreviewFeatures: (state) => {
            state.debug_preview_features = !state.debug_preview_features;
        },
    },
});

// Export the reducer function and action creators from the slice
export const { toggleDebugPreviewFeatures } = debugSlice.actions;
export const reducer = debugSlice.reducer;
